export const HELP_ME_TICKET_URL =
  "https://helpme.myob.com/hc/en-us/requests/new?ticket_form_id=11439419669401&tf_11438992067993=pl_employment_forms_issues";

export const EOY_HELP_ME_TICKET_URL =
  "https://helpme.myob.com/hc/en-us/requests/new?ticket_form_id=11472102774681&tf_11472135866777=infrastructure_ps_automation_tech_issues&tf_12236557661081=empf_end-of-year_indicative_rating";

export const PURCHASED_LEAVE_HELP_ME_TICKET_URL =
  "https://helpme.myob.com/hc/en-us/requests/new?ticket_form_id=12237031585049&tf_12236885984921=people_leave_purchasing";
